import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { NgxTurnstileModule, NgxTurnstileFormsModule } from "ngx-turnstile";
import { environment } from '../../environments/environment';
import { TurnstileService } from '../core/services/turnstile.service';
import { ContactUsService } from '../core/services/contact-us.service';
import { LanguageService } from '../core/services/language.service';


@Component({
  selector: 'app-contact-mx',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgxTurnstileModule],
  templateUrl: './contact-mx.component.html',
  styleUrl: './contact-mx.component.css'
})
export class ContactMxComponent implements OnInit {
  @Output()
  formReady = new EventEmitter<FormGroup>();

  @Input()
  parentForm: FormGroup;

  @Input()
  showValidationError = false;

  @Input()
  showSubmissionError = false;

  siteKey = environment.turnstileSiteKey;

  loaderIcon: boolean = false;

  constructor(private fb: FormBuilder, private turnstileService: TurnstileService, private contactUsService: ContactUsService, private languageService: LanguageService) {}

  form: FormGroup;

  get labels() { return this.contactUsService.contactDetailsLabels; }
  get commonLabels() { return this.contactUsService.commonLabels; }
  get placeholders() { return this.contactUsService.placeholderTextLabels; }
  get messages() { return this.contactUsService.messageLabels; }

  ngOnInit(): void {

    const lang = this.languageService.getLanguageFromUrl();

    this.contactUsService.getDictionary(lang).subscribe();

    this.form = this.fb.group({
      country: [''],
      preferredLanguage: [''],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      confirmEmail: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.pattern(/^\+?[0-9\s\-()]{7,30}$/)]],
      message: ['', [Validators.required, Validators.minLength(20)]],
      agreeTerms: [false, [Validators.requiredTrue]],
      turnstile: ['', [Validators.required]]
    }, { validators: this.emailMatchValidator });

    this.formReady.emit(this.form);
  }

  onCaptchaResolved(token: string): void {
    this.form.get('turnstile')?.setValue(token);
    this.turnstileService.setToken(token);
  }

  emailMatchValidator(control: AbstractControl): ValidationErrors | null {
    const email = control.get('email')?.value;
    const confirmEmail = control.get('confirmEmail')?.value;

    if (!email || !confirmEmail) {
      return null;
    }

    return email === confirmEmail ? null : { emailMismatch: true };
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  hasEmailMismatch(): boolean {
    return !!(
      this.form.hasError('emailMismatch') &&
      this.form.get('confirmEmail')?.touched
    );
  }
}
